import type { ReactNode } from 'react'
import { useEffect } from 'react'
import TagManager from 'react-gtm-module'

import { useAuth } from '@fourthwall/auth'
import { isProduction } from '@fourthwall/utils/dist/dev'

import { useCurrentShop } from '../../Dashboard/hooks/useCurrentShop'

export const TagManagerProvider = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth()
  const { currentShop } = useCurrentShop()

  useEffect(() => {
    if (!user?.id || !currentShop) return

    TagManager.dataLayer({
      dataLayer: {
        userId: user?.id,
        userEmail: user?.email,
        leadTier: currentShop.leadTier,
        shopId: currentShop.id,
        activeExperiments: currentShop.activeExperiments ?? [],
      },
    })

    if (isProduction()) {
      TagManager.initialize({ gtmId: 'GTM-NNJWLDT' })
    }
  }, [user?.id, currentShop])

  return children
}
